var _path;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgCopyOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22224 0.320312C1.61908 0.320312 0.319458 1.61993 0.319458 3.22309V8.50087C0.319458 10.104 1.61908 11.4036 3.22224 11.4036V9.82031C2.49353 9.82031 1.90279 9.22958 1.90279 8.50087V3.22309C1.90279 2.49438 2.49353 1.90365 3.22224 1.90365H8.50001C9.22872 1.90365 9.81946 2.49438 9.81946 3.22309H11.4028C11.4028 1.61993 10.1032 0.320312 8.50001 0.320312H3.22224ZM8.50001 5.59809C6.89685 5.59809 5.59724 6.89771 5.59724 8.50087V13.7786C5.59724 15.3818 6.89685 16.6814 8.50001 16.6814H13.7778C15.381 16.6814 16.6806 15.3818 16.6806 13.7786V8.50087C16.6806 6.89771 15.381 5.59809 13.7778 5.59809H8.50001ZM7.18057 8.50087C7.18057 7.77216 7.7713 7.18142 8.50001 7.18142H13.7778C14.5065 7.18142 15.0972 7.77216 15.0972 8.50087V13.7786C15.0972 14.5074 14.5065 15.0981 13.7778 15.0981H8.50001C7.7713 15.0981 7.18057 14.5074 7.18057 13.7786V8.50087Z",
    fill: "var(--secondary-7)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyOutlined);
export default __webpack_public_path__ + "static/media/copyOutlined.1b376c0875b5dd9b6081f69c4faeab40.svg";
export { ForwardRef as ReactComponent };